import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { AccountsModule } from './accounts/accounts.module';
import { OoPagesModule } from './oo-pages/oo-pages.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from 'smart-webcomponents-angular/grid';
import { AuthInterceptor } from './utils/auth.interceptor';
import { LoaderInterceptor } from './utils/loader.interceptor';
import { SnackbarService } from './services/snackbar.service';
import { LoaderComponent } from './common-section/loader/loader.component';
import { CommonSectionModule } from './common-section/common-section.module';
import { DailyLogsModule } from './daily-logs/daily-logs.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/resources/i18n/', '.json');
}
window.Smart.License = "BEF3B03B-0387-45A0-B2BF-8594E6CF770C";




@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AccountsModule,
    OoPagesModule,
    ReactiveFormsModule,
    FormsModule,
    GridModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    CommonSectionModule,
    DailyLogsModule
    
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    { provide: 'WINDOW', useValue: window },
    SnackbarService,
    TranslateService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
